/* eslint-disable vue/max-len */
import { create } from '@bufbuild/protobuf';

import * as pbm from '@/grpc-gen/message_center_service_pb';
import MessageSettings from './message-settings';
import MessageTranslation from './message-translation';

export default class MessageCenterPreferences {
  settings: MessageSettings = new MessageSettings();

  translations: MessageTranslation[] = [];

  static fromGrpcResponse(req: pbm.MessageCenterPreferencesResponse): MessageCenterPreferences {
    const preferences = new MessageCenterPreferences();
    preferences.settings = MessageSettings.fromGrpcModel(req.settings);
    preferences.translations = (req.translations ?? []).map((translation) => MessageTranslation.fromGrpcModel(translation));
    return preferences;
  }

  static toGrpcRequest(preferences: MessageCenterPreferences): pbm.MessageCenterPreferencesRequest {
    return create(pbm.MessageCenterPreferencesRequestSchema, {
      settings: MessageSettings.toGrpcModel(preferences.settings),
      translations: (preferences.translations ?? []).map((t) => MessageTranslation.toGrpcModel(t)),
    });
  }
}
